<template>
    <div>
        <Header title="测评用户" memo="管理测评用户信息"></Header>
        <a-divider />
        <div class="flex-x-space-between" :style="{ marginTop: '16px' }">
            <div>
                <a-button type="primary" icon="plus" @click="showAddForm" :style="{ marginRight: '8px' }">
                    添加
                </a-button>

                <a-button type="danger" icon="delete" @click="execDelete" :style="{ marginRight: '8px' }" :disabled="selRows.length === 0">
                    删除
                </a-button>
            </div>
            <div>
                <a-form-model layout="inline" :model="query">
                    <a-form-model-item>
                        <a-select show-search v-model="query.oid" :filter-option="false" :not-found-content="null" @search="doLoadOrg" @change="execQuery" :style="{ width: '100px' }">
                            <a-select-option value="">
                                所有组织
                            </a-select-option>
                            <a-select-option v-for="item in orgs" :key="item.id" :value="item.id" :label="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.id" placeholder="用户账号" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.name" placeholder="用户名称" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-input v-model="query.mob" placeholder="用户手机" @pressEnter="execQuery" :style="{ width: '100px' }">
                            <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="search" @click="execQuery">
                            查询
                        </a-button>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-button icon="retweet" @click="execReload">
                            刷新
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>
        </div>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.id" :data-source="datas" :loading="loading" :row-selection="{ type: 'checkbox', onChange: onSelectChange }" bordered :pagination="false">
            <a-table-column key="id" ellipsis width="450px">
                <span slot="title">用户信息</span>
                <template slot-scope="text, record">
                    <a-popover placement="top">
                        <template slot="content">
                            <p>
                                用户账号：
                                <span>{{ record.id }}</span>
                            </p>
                            <p>
                                用户姓名：
                                <span>{{ record.name }}</span>
                            </p>
                            <p>
                                身份证号：
                                <span>{{ record.idno }}</span>
                            </p>
                            <p>
                                联系电话：
                                <span>{{ record.mob }}</span>
                            </p>
                            <p>
                                用户分组：
                                <span>{{ record.org.name }}</span>
                            </p>
                            <p>
                                出生日期：
                                <span>{{ record.bir }}</span>
                            </p>
                            <p>
                                性别：
                                <span>{{ record.gender === 'M' ? '男' : '女' }}</span>
                            </p>
                            <p>
                                训练师：
                                <span>{{ record.cta }}</span>
                            </p>
                            <p>
                                添加人：
                                <span>{{ record.create.name }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>用户信息</span>
                        </template>
                        <span>{{ record.name }} [{{ record.id }}] / {{ record.gender === 'M' ? '男' : '女' }} / {{ record.mob }} / {{ record.org.name }}</span>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="device" ellipsis>
                <span slot="title">当前设备</span>
                <template slot-scope="text, record">
                    <template v-if="record.device.id && record.device.type !== 'Home'" :style="{ marginRight: '10px' }">
                        <a-popconfirm title="是否解除绑定设备？" @confirm="doUnbindDevice(record.id, record.device.id)">
                            <a-icon slot="icon" type="question-circle-o" style="color: red" />

                            <a-button type="link" style="color: red" icon="delete">
                                解绑
                            </a-button>
                        </a-popconfirm>
                    </template>
                    <a-popover placement="top" v-if="record.device.id">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.device.sno }}</span>
                            </p>
                            <p>
                                名称：
                                <span>{{ record.device.name }}</span>
                            </p>
                            <p>
                                时间：
                                <span>{{ record.device.bind }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>设备信息</span>
                        </template>
                        <span>[ {{ record.device.sno }} ] {{ record.device.name }}</span>
                    </a-popover>
                    <a-popover placement="top" trigger="click" v-else>
                        <template slot="content">
                            <a-form-model layout="inline">
                                <a-form-model-item>
                                    <a-select show-search v-model="bindDevice" :filter-option="false" :not-found-content="null" @search="doLoadDevice" :style="{ width: '200px' }">
                                        <a-select-option v-for="item in devices" :key="item.id" :value="item.id" :label="item.name">[{{ item.sno }}] {{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="retweet" @click="doLoadDevice"></a-button>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <a-button icon="link" @click="doBindDevice(record.id)">
                                        提交绑定
                                    </a-button>
                                </a-form-model-item>
                            </a-form-model>
                        </template>
                        <template slot="title">
                            <span>选择设备进行绑定</span>
                        </template>

                        <a-button type="link" style="color: blue">
                            绑定设备
                        </a-button>
                    </a-popover>
                </template>
            </a-table-column>
            <a-table-column key="testing" ellipsis width="250px">
                <span slot="title">当前测评</span>
                <template slot-scope="text, record">
                    <!-- <template v-if="record.testing.id" :style="{ marginRight: '10px' }">
                        <template v-if="record.testing.type === 'Exam'">
                            <a-popconfirm title="是否中止进行中的测评？" @confirm="doAbortTesting(record.testing.id)" v-if="record.testing.state != 'Finish' && record.testing.state != 'Abort'">
                                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                                <a-icon type="stop" style="color: red" />
                            </a-popconfirm>
                        </template>
                        <template v-else>
                            <a-popconfirm title="是否完成进行中的训练？" @confirm="doFinishTesting(record.testing.id)" v-if="record.testing.state != 'Finish' && record.testing.state != 'Abort'">
                                <a-icon slot="icon" type="question-circle-o" style="color: orchid" />
                                <a-icon type="check" style="color: orange" />
                            </a-popconfirm>
                        </template>
                    </template> -->
                    <a-popover placement="top" v-if="record.testing.id">
                        <template slot="content">
                            <p>
                                编号：
                                <span>{{ record.testing.id }}</span>
                            </p>
                            <p>
                                状态：
                                <span>{{ record.testing.state | testingState }}</span>
                            </p>
                            <p>
                                类型：
                                <span>{{ record.testing.type === 'Exam' ? '测验模式' : '训练模式' }}</span>
                            </p>
                            <p>
                                进度：
                                <span>{{ record.testing.step }}</span>
                            </p>
                        </template>
                        <template slot="title">
                            <span>测评信息</span>
                        </template>
                        <template>{{ record.testing.type === 'Exam' ? '测验' : '训练' }}模式 [{{ record.testing.step }}]</template>
                    </a-popover>
                    <a-tag color="#2db7f5" v-else>暂无测评</a-tag>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                        编辑
                    </a-button>
                    <a-popconfirm :title="'是否删除用户[' + record.name + ']，删除后无法恢复'" ok-type="danger" ok-text="确认删除" cancel-text="取消" @confirm="doDelete(record.id)">
                        <a-button type="link" icon="delete">
                            删除
                        </a-button>
                    </a-popconfirm>
                </template>
            </a-table-column>
        </a-table>

        <a-pagination
            :style="{ marginTop: '15px' }"
            :total="pager.rows"
            :current="query.page"
            :show-total="total => `共计 ${total} 条数据`"
            show-quick-jumper
            show-less-items
            show-size-changer
            hide-on-single-page
            :page-size.sync="query.size"
            :page-size-options="['10', '25', '50', '100']"
            @change="onChangePage"
            @showSizeChange="onChangeSize"
        />

        <FormComp title="编辑测评用户" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>
    </div>
</template>

<script>
import FormComp from './FormComp'

export default {
    name: 'AteUnitTester',
    components: {
        FormComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        },
        rowSelection() {
            return {
                onChange: this.onSelectRows
            }
        }
    },
    data() {
        return {
            orgs: [],
            devices: [],
            bindDevice: '',
            query: {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                oid: '',
                id: '',
                name: '',
                mob: ''
            },
            selRows: [],
            datas: [],
            pager: {
                rows: 0,
                pnum: 1,
                pnow: 1,
                time: 0
            },
            form: false,
            now: {}
        }
    },
    filters: {
        testingState: value => {
            switch (value) {
                case 'Wait':
                    return '未开始'
                case 'Run':
                    return '进行中'
                case 'Pause':
                    return '暂停中'
                case 'Finish':
                    return '已完成'
                case 'Abort':
                    return '已中止'
            }
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['云测评', '测评用户'])
        this.doLoadOrg()
        this.doLoadDevice()
        this.doLoad()
    },
    methods: {
        doLoadDevice() {
            this.$http
                .get('/cts/ate/device/mgr/query', {
                    params: {
                        state: 'Idle',
                        size: 20
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.devices = result.datas
                })
        },
        doLoadOrg(name) {
            this.$http
                .get('/cts/ate/tester/org/query', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.orgs = result.datas
                })
        },
        doLoad() {
            this.$http
                .get('/cts/ate/tester/info/list', {
                    params: this.query,
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    if (result.data.pnow === 1) {
                        this.query.time = result.data.time
                    }
                    this.pager = result.data
                    this.datas = result.datas
                })
        },
        doDelete(ids) {
            this.$http
                .post('/cts/ate/tester/info/delete', {
                    ids: typeof ids === 'string' ? ids : ids.join()
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('删除成功')
                        this.doLoad()
                    }
                })
        },
        doBindDevice(tid) {
            if (!this.bindDevice) {
                this.$message.error('请选择要绑定的设备')
                return
            }
            this.$http
                .post('/cts/ate/device/mgr/tester/set', {
                    tid: tid,
                    id: this.bindDevice,
                    flag: true
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('绑定成功')
                        this.bindDevice = ''
                        this.doLoad()
                    }
                })
        },
        doUnbindDevice(tid, did) {
            this.$http
                .post('/cts/ate/device/mgr/tester/set', {
                    tid: tid,
                    id: did,
                    flag: false
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('解绑成功')
                        this.doLoad()
                    }
                })
        },
        doAbortTesting(id) {
            this.$http
                .post('/cts/ate/testing/mgr/abort', {
                    id: id,
                    cause: '中止测评'
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('中止测评成功')
                        this.doLoad()
                    }
                })
        },
        doFinishTesting(id) {
            this.$http
                .post('/cts/ate/testing/mgr/finish', {
                    id: id
                })
                .then(result => {
                    if (result.code === 0) {
                        this.$message.success('操作成功')
                        this.doLoad()
                    }
                })
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selRows = selectedRows
        },
        onChangePage(page) {
            this.query.page = page
            this.doLoad()
        },
        onChangeSize(page, size) {
            this.query.size = size
            this.query.page = 1
            this.doLoad()
        },
        execQuery() {
            this.query.page = 1
            this.doLoad()
        },
        execReload() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unit: '',
                oid: '',
                id: '',
                name: '',
                mob: ''
            }
            this.doLoad()
        },
        showAddForm() {
            this.now = {}
            this.form = true
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        },

        execDelete() {
            let names = []
            let ids = []
            this.selRows.forEach(row => {
                names.push(row.name)
                ids.push(row.id)
            })
            if (ids.length === 0) {
                this.$message.error('请选择要删除的用户')
                return
            }
            this.$confirm({
                title: '是否删除以下用户？删除后无法恢复。',
                content: '用户：[' + names.join() + ']',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.doDelete(ids)
                }
            })
        }
    }
}
</script>
